"use client";

import { Extension } from "@tiptap/core";
import type { Editor } from "@tiptap/core";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        textDirection: {
            setBlockDirection: (dir: "ltr" | "rtl") => ReturnType;
            unsetBlockDirection: () => ReturnType;
        };
    }
}

const DIRECTABLE_NODES = ["paragraph", "heading"];

/** Adds a `dir` attribute to paragraph/heading nodes for per-block RTL/LTR. */
export const TextDirection = Extension.create({
    name: "textDirection",

    addGlobalAttributes() {
        return [
            {
                types: DIRECTABLE_NODES,
                attributes: {
                    dir: {
                        default: null,
                        parseHTML: (element) =>
                            element.getAttribute("dir") || null,
                        renderHTML: (attributes) =>
                            attributes.dir ? { dir: attributes.dir } : {},
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setBlockDirection:
                (dir: "ltr" | "rtl") =>
                ({
                    state,
                    chain,
                }: {
                    state: Editor["state"];
                    chain: Editor["chain"];
                }) => {
                    const nodeType = state.selection.$from.parent.type.name;
                    if (!DIRECTABLE_NODES.includes(nodeType)) return false;
                    return chain().updateAttributes(nodeType, { dir }).run();
                },
            unsetBlockDirection:
                () =>
                ({
                    state,
                    chain,
                }: {
                    state: Editor["state"];
                    chain: Editor["chain"];
                }) => {
                    const nodeType = state.selection.$from.parent.type.name;
                    if (!DIRECTABLE_NODES.includes(nodeType)) return false;
                    return chain()
                        .updateAttributes(nodeType, { dir: null })
                        .run();
                },
        };
    },
});
